/* global jQuery */

jQuery(function ($) {

  $(document).on("click", "[data-modal]", function (e) {
    e.preventDefault();

    const id = $(this).data("modal");
    const $modal = $(`.modal[data-id="${id}"]`);
    const $template = $modal.find("template");

    if ($template.length) {
      const content = $template[0].content.cloneNode(true);
      $modal.append(content);
      $template.remove();
    }

    $("body").addClass("body-fixed");
    $modal.addClass("active");

  });

  $(document).on("click", "[data-modal-close]", function (e) {
    e.preventDefault();

    const $el = $(this);

    $el.closest(".modal").removeClass("active");

    $("body").removeClass("body-fixed");

  });

  $(document).on("mousedown", ".modal", function (e) {
    const $target = $(e.target);
    if (!$target.closest(".modal-wrap").length) {
      $(this).removeClass("active");
      $("body").removeClass("body-fixed");
    }
  });

})
